const utils = require('utils/**/*.js', { mode: 'hash', resolve: ['reduce', 'strip-ext'] });
const { ready } = utils.DOMHelpers.default;

/**
 * A function purely needed for development to make the current menu-item acitve
 */
function makeCorrectMenuItemActive() {
    const pathName = document.location.pathname;
    const startString = '/templates/';
    const jumpToNextCharacterThreshold = 4;

    const start = pathName.indexOf(startString) + startString.length;
    const end = pathName.indexOf('/', startString.length + jumpToNextCharacterThreshold);
    const urlPartial = pathName.slice(start, end);

    const menuItems = Array.from(document.querySelectorAll('.main-nav__link'));
    menuItems.forEach(menuItem => {
        if (menuItem.href.includes(urlPartial)) {
            return menuItem.classList.add('main-nav--active');
        }
        return menuItem.classList.remove('main-nav--active');
    });
}

window.makeCorrectMenuItemActive = makeCorrectMenuItemActive;
ready().then(makeCorrectMenuItemActive);
